import * as React from "react";

import { cn } from "lib/utils";

type PageContainerMaxWidth =
  | "screen-xl"
  | "6xl"
  | "5xl"
  | "4xl"
  | "3xl"
  | "none";

interface PageContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  maxWidth?: PageContainerMaxWidth;
  withHorizontalPadding?: boolean;
}

const MAX_WIDTH_CLASSES: Record<PageContainerMaxWidth, string> = {
  "screen-xl": "max-w-screen-xl",
  "6xl": "max-w-6xl",
  "5xl": "max-w-5xl",
  "4xl": "max-w-4xl",
  "3xl": "max-w-3xl",
  none: "max-w-none",
};

export const PageContainer: React.FC<PageContainerProps> = ({
  className,
  maxWidth = "screen-xl",
  withHorizontalPadding = true,
  ...props
}) => (
  <div
    className={cn(
      "mx-auto w-full min-w-0",
      MAX_WIDTH_CLASSES[maxWidth],
      withHorizontalPadding && "px-4 sm:px-6 lg:px-8",
      className,
    )}
    {...props}
  />
);

